import { render, staticRenderFns } from "./folder-section.vue?vue&type=template&id=5359568b&"
import script from "./folder-section.vue?vue&type=script&lang=js&"
export * from "./folder-section.vue?vue&type=script&lang=js&"
import style0 from "./folder-section.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports